import styled from 'styled-components';

// CONSTANTS
import { DANDELION } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

const AboutCoolFeaturesSection = styled.section`
  position: relative;

  padding: 88px 0 40px;

  .about-cool-features {
    &__bg-line {
      position: absolute;
      top: 0;
      right: 0;
      color: ${DANDELION};
      z-index: -1;
    }

    &__subtitle {
      margin-top: 8px;
    }
  }

  ${breakpoints.up('md')} {
    padding: 80px 0 100px;

    .about-cool-features {
      &__subtitle {
        margin-top: 12px;
      }
    }
  }
`;

export default AboutCoolFeaturesSection;
